import * as ng from 'angular';

ng.module('e360')
   .directive('uniqueUserEmail', uniqueUserEmailDirective);

uniqueUserEmailDirective.$inject = ['userApi'];
export function uniqueUserEmailDirective(userApi) {
   return {
      restrict: 'A',
      require: 'ngModel',
      link: uniqueUserEmailDirectiveLink,
      scope: {
         myId: '=uniqueUserEmail'
      }
   };

   function uniqueUserEmailDirectiveLink(
      scope:ng.IScope, element:ng.IAugmentedJQuery, attrs:ng.IAttributes,
      ctrl:ng.INgModelController
   ) {
      element.on('blur', () => {
         let email = ctrl.$viewValue;

         ctrl.$setValidity('uniqueUserEmail', true);

         if (email) {
            userApi.checkUniqueEmail(email, scope['myId']).catch(() => {
               ctrl.$setValidity('uniqueUserEmail', false);
            });
         }
      });
   }
}
